module.exports = __webpack_public_path__ + "img/deposit.34149136.svg";